import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "1.jpg",
        title: "Track a Shipment",
        crumb: "Track a Shipment"
    }
}